import PropTypes from "prop-types";
import styles from "./index.css";
import formatPrice from "../formatPrice";

const FormattedPrice = ({ value }) => (
  <span className={styles.noWrap}>{formatPrice(value)}</span>
);

FormattedPrice.propTypes = {
  value: PropTypes.number.isRequired
};

export default FormattedPrice;
